// eslint-disable-next-line import/prefer-default-export
export enum GlobalAppType {
  MainApp = 'mainApp',
  SimpleLogin = 'simpleLogin',
}
